var React = require('react');

function CloseWhite (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Combined Shape"),React.createElement("g",{"id":"//-Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"icons/Navigation/Close-Arrow-White","transform":"translate(-5.000000, -5.000000)","stroke":"#FFFFFF","strokeWidth":"2"},React.createElement("path",{"d":"M17.6470588,6.35294118 L6.35294118,17.6470588 M17.6470588,17.6470588 L6.35294118,6.35294118","id":"Combined-Shape"})))]);
}

CloseWhite.defaultProps = {"width":"14px","height":"14px","viewBox":"0 0 14 14","version":"1.1"};

module.exports = CloseWhite;

CloseWhite.default = CloseWhite;
